import { User } from "../models/data";
import Urls from "./url";

export const fetchPmtInitationData = async (user:User,amount:any,intention:any,language:any) => {
    let body={
        fistName:user.firstName,
        lastName:user.lastName,
        fullName:`${user.firstName} ${user.lastName}`,
        dateOfBirth:user.dateOfBirth,
        email:user.email,
        userId:user.id*215,
        action:`${intention==="credit"?`crediting `:`donating`}`,
        amount:amount,
        language:language
    }

    let resp = await fetch(Urls('getPaymentInterface'),
        {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ',// + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header

        }
        ).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const upDatePaymentInfo = async (user:User,amount:any,intention:any,transactionId:any,version:any) => {
    let newversion;
    if(version<=2){
        newversion=3;
    }else{
        newversion=version+1
    }
    let body={
        fistName:user.firstName,
        lastName:user.lastName,
        fullName:`${user.firstName} ${user.lastName}`,
        dateOfBirth:user.dateOfBirth,
        email:user.email,
        userId:user.id*215,
        transactionId:transactionId,
        action:`${intention==="credit"?`crediting `:`donating`}`,
        amount:amount,
        version:newversion
    }

    let resp = await fetch(Urls('updatePayment'),
        {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ',// + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header

        }
        )

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const confirmPaymentInfo = async (user:User,amount:any,intention:any,transactionId:any,actionId:any,version:any) => {
    
    let body={
        fistName:user.firstName,
        lastName:user.lastName,
        fullName:`${user.firstName} ${user.lastName}`,
        dateOfBirth:user.dateOfBirth,
        email:user.email,
        userId:user.id*215,
        transactionId:transactionId,
        actionId:actionId,
        action:`${intention==="credit"?`crediting `:`donating`}`,
        amount:amount,
        version:version+2
    }
    let resp = await fetch(Urls('confirmPayment'),
        {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ',// + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header

        }
        )

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        console.log(resp)
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export default {};